import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import ogImageJpeg from './assets/OgImage.jpeg'

const LinkedProfilesView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Linked Profiles Beta Sign Up | Twilio Segment"
        pageDescription="Linked Profiles makes it easy to bring data from your warehouse into any tracked event in Segment before it is sent to any of our supported applications. Sign up to get on the list for our beta program today and to be notified when we move into GA later this year."
        pageOG={ogImageJpeg}
      >
        <NavigationV2 />
        <main>
          <Hero />
        </main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

export default LinkedProfilesView
